import React, { useState, useContext } from "react";
import "../styles/Navbar.css";
import LoginModal from "./LoginModal";
import { AuthContext } from '../AuthContext';
import user_account_icon from "../assets/user-account-icon.png";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [aboutDropdownOpen, setAboutDropdownOpen] = useState(false);
  const { loggedInUser } = useContext(AuthContext);

  const toggleAboutDropdown = () => {
    setAboutDropdownOpen(!aboutDropdownOpen);
  };

  return (
    <nav className="navbar">
      {/* Hamburger Icon for Mobile */}
      <button className="menu-toggle" onClick={() => {
              setMenuOpen(!menuOpen);
              if (menuOpen) {
                setAboutDropdownOpen(false);
              }
            }}>
        ☰
      </button>

      {/* Navigation Links */}
      <ul className={`nav-links ${menuOpen ? "open" : ""}`}>
        <li><a href="/">Home</a></li>
        
        {/* About Us with Dropdown */}
        <li 
          className={`dropdown ${aboutDropdownOpen ? "active" : ""}`}
        >
          <a 
            href="/about-us" 
            className="dropdown-toggle"
            onClick={(e) => {
              if (window.innerWidth <= 968) {
                e.preventDefault();
                toggleAboutDropdown();
              }
            }}
          >
            About Us <span className="dropdown-arrow">▼</span>
          </a>
          <ul className={`dropdown-menu ${aboutDropdownOpen ? "show" : ""}`}>
            <li><a href="/ministries">Ministries</a></li>
            <li><a href="/about-us/church-constitution">Church Constitution</a></li>
            <li><a href="/about-us/statement-of-faith">Statement of Faith</a></li>
          </ul>
        </li>

        <li><a href="/blog">Blog</a></li>
        <li><a href="/online-sermons">Online Sermons</a></li>
        {/* <li><a href="/resources">Resources</a></li> */}
        {/* <li><a href="/about-us/statement-of-faith">Statement of Faith</a></li> */}
        <li><a href="/contact-us">Contact Us</a></li>
      </ul>

      {/* Profile Icon */}
      <button className="profile-icon" onClick={() => setModalOpen(true)}>
        <img src={user_account_icon} alt="Account Login Image" className="icon-img" />
      </button>

      <LoginModal isOpen={modalOpen} onClose={() => setModalOpen(false)} />
    </nav>
  );
};

export default Navbar;